import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import logo from './NeoStats black text.png';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const quickLoginCredentials = {
    email: 'RM360@NeoStats.com',
    password: 'NeoStats@1234',
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Required'),
    password: Yup.string()
      .required('Required'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit: (values) => {
      // Hardcoded credentials for demo
      if (values.email === 'RM360@NeoStats.com' && values.password === 'NeoStats@1234') {
        localStorage.setItem('isAuthenticated', 'true');
        onLogin();
        toast.success('Successfully logged in!');
        navigate('/dashboard');
      } else {
        toast.error('Invalid credentials');
      }
    },
  });

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-950">
      {/* Bank-themed image background + green tint */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        {/* Base image */}
        <div
          className="absolute inset-0 bg-center bg-no-repeat bg-cover"
          style={{ backgroundImage: "url('/c14feb99893c24282923db1ee60b2353.jpg')" }}
        />

        {/* Green tint filter layer */}
        <div className="absolute inset-0 bg-emerald-950/55 mix-blend-multiply" />

        {/* Gentle sheen to add depth */}
        <div className="absolute inset-0 bg-[linear-gradient(115deg,rgba(16,185,129,0.22)_0%,rgba(2,6,23,0.10)_35%,rgba(250,204,21,0.10)_70%,rgba(16,185,129,0.18)_100%)]" />

        {/* Vignette to focus attention on the card */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.10)_0%,rgba(0,0,0,0.72)_62%,rgba(0,0,0,0.92)_100%)]" />
      </div>

      <div className="relative max-w-md w-full space-y-8 p-8 rounded-2xl border border-white/10 bg-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.45)] backdrop-blur-xl">
        <div className="text-center">
           <img 
              src={logo}
              alt='' 
              className='w-160 h-160 object-contain'
            />
          {/* <h1 className="text-4xl font-bold mb-2">Housing Bank</h1> */}
          <h2 className="text-3xl font-bold text-white">RM 360 Dashboard</h2>
          <p className="mt-2 text-sm text-white/70">Secure access for banking insights and operations.</p>
        </div>

        <form onSubmit={formik.handleSubmit} className="mt-8 space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-white/80">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              {...formik.getFieldProps('email')}
              className="mt-1 block w-full px-3 py-2 rounded-md border border-white/10 bg-white/90 shadow-sm text-gray-900 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-300/60 focus:border-emerald-300/60"
              placeholder="Enter your email"
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="text-red-500 text-sm mt-1">{formik.errors.email}</div>
            ) : null}
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-white/80">
              Password
            </label>

            
            <input
              id="password"
              name="password"
              type="password"
              {...formik.getFieldProps('password')}
              className="mt-1 block w-full px-3 py-2 rounded-md border border-white/10 bg-white/90 shadow-sm text-gray-900 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-300/60 focus:border-emerald-300/60"
              placeholder="Enter your password"
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="text-red-500 text-sm mt-1">{formik.errors.password}</div>
            ) : null}
          </div>

          <div>
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 rounded-md shadow-sm text-sm font-medium text-emerald-950 bg-gradient-to-r from-emerald-200 via-emerald-100 to-amber-100 hover:from-emerald-100 hover:to-amber-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-200 focus:ring-offset-slate-950"
            >
              Sign In
            </button>
          </div>

          <div>
            <button
              type="button"
              onClick={() => {
                formik.setValues(quickLoginCredentials, false);
                formik.submitForm();
              }}
              className="w-full flex justify-center py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-white/10 border border-white/15 hover:bg-white/15 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white/40 focus:ring-offset-slate-950"
            >
              Quick Login
            </button>
          </div>

          <div className="text-sm text-center">
            <a href="/forgot-password" className="text-white/70 hover:text-white">
              Forgot password?
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
